<div class="restrictions-container">
    <div class="banner">
        <div class="title">
            <fa-icon [icon]="faAngleRight"></fa-icon>
            <span>{{ 'Restrictions.Title' | translate }}</span>
        </div>

        <div class="action-zone">
            <button color="accent" mat-button routerLink="/restriction">
                {{ 'Restrictions.ButtonRestrictionCreation' | translate }}
                <mat-icon>add_circle</mat-icon>
            </button>
        </div>
    </div>

    <div class="table-container">
        <form class="filters-form" [formGroup]="filtersForm">
            <div class="mat-elevation-z8">
                <table mat-table [dataSource]="dataSource" matSort>
                    <!-- <ng-container matColumnDef="id">
          <th mat-header-cell *matHeaderCellDef>
            <span mat-sort-header>{{'Restrictions.ColumnHeaderId'|translate}}</span>
            <mat-form-field>
              <input matInput formControlName="id" (keyup)="applyFilters()" autocomplete="off"/>
              <button mat-icon-button matSuffix class="header-button" matTooltip="{{ 'Restrictions.ResetFilterColumn' | translate }}"
                (click)="resetColumnFilter('id')" type="button">
                <mat-icon>undo</mat-icon>
              </button>
            </mat-form-field>
          </th>
          <td mat-cell *matCellDef="let element"> {{element.id}} </td>
        </ng-container> -->

                    <ng-container matColumnDef="name">
                        <th mat-header-cell *matHeaderCellDef>
                            <span mat-sort-header>{{ 'Restrictions.ColumnHeaderName' | translate }}</span>
                            <div class="small">
                                <mat-form-field class="form-field" appearance="outline">
                                    <input matInput formControlName="name" (keyup)="applyFilters()" autocomplete="off" />
                                    <button
                                        mat-icon-button
                                        matSuffix
                                        class="mat-accent search-icon"
                                        matTooltip="{{ 'Restrictions.ResetFilterColumn' | translate }}"
                                        (click)="resetColumnFilter('name')">
                                        <mat-icon>undo</mat-icon>
                                    </button>
                                </mat-form-field>
                            </div>
                        </th>
                        <td mat-cell *matCellDef="let element">{{ element.name }}</td>
                    </ng-container>

                    <ng-container matColumnDef="enabled">
                        <th mat-header-cell *matHeaderCellDef>
                            <span mat-sort-header>{{ 'Restrictions.ColumnHeaderEnabled' | translate }}</span>
                            <div class="checkbox-header">
                                <mat-checkbox
                                    color="accent"
                                    formControlName="enabled"
                                    [indeterminate]="checkBoxStatus === null"
                                    [checked]="checkBoxStatus"
                                    (change)="checkBoxChange()"></mat-checkbox>
                                <button
                                    mat-icon-button
                                    matSuffix
                                    class="mat-accent search-icon"
                                    matTooltip="{{ 'Restrictions.ResetFilterColumn' | translate }}"
                                    (click)="resetColumnFilter('enabled')">
                                    <mat-icon>undo</mat-icon>
                                </button>
                            </div>
                        </th>
                        <td mat-cell *matCellDef="let element">
                            <mat-checkbox [checked]="element.enabled" disabled></mat-checkbox>
                        </td>
                    </ng-container>

                    <ng-container matColumnDef="extension">
                        <th mat-header-cell *matHeaderCellDef>
                            <span mat-sort-header>{{ 'Restrictions.ColumnHeaderExtension' | translate }}</span>
                            <div class="small">
                                <mat-form-field class="form-field" appearance="outline">
                                    <input matInput formControlName="extension" (keyup)="applyFilters()" autocomplete="off" />
                                    <button
                                        mat-icon-button
                                        matSuffix
                                        class="mat-accent search-icon"
                                        matTooltip="{{ 'Restrictions.ResetFilterColumn' | translate }}"
                                        (click)="resetColumnFilter('extension')">
                                        <mat-icon>undo</mat-icon>
                                    </button>
                                </mat-form-field>
                            </div>
                        </th>
                        <td mat-cell *matCellDef="let element">{{ element.extension | extensionDisplay }}</td>
                    </ng-container>

                    <ng-container matColumnDef="type">
                        <th mat-header-cell *matHeaderCellDef>
                            <span mat-sort-header>{{ 'Restrictions.ColumnHeaderType' | translate }}</span>
                            <div class="small">
                                <mat-form-field class="form-field" appearance="outline">
                                    <mat-select formControlName="type" (selectionChange)="applyFilters()">
                                        @for (type of restrictionTypes; track type) {
                                        <mat-option [value]="type">
                                            {{ 'EnumRestrictionTypes.' + type | translate }}
                                        </mat-option>
                                        }
                                    </mat-select>
                                    <button
                                        mat-icon-button
                                        matSuffix
                                        class="mat-accent search-icon"
                                        matTooltip="{{ 'Restrictions.ResetFilterColumn' | translate }}"
                                        (click)="resetColumnFilter('type'); $event.stopPropagation()"
                                        type="button">
                                        <mat-icon>undo</mat-icon>
                                    </button>
                                </mat-form-field>
                            </div>
                        </th>
                        <td mat-cell *matCellDef="let element">{{ 'EnumRestrictionTypes.' + element.type | translate }}</td>
                    </ng-container>

                    <ng-container matColumnDef="calendar">
                        <th mat-header-cell *matHeaderCellDef>
                            <span mat-sort-header>{{ 'Restrictions.ColumnHeaderCalendar' | translate }}</span>
                            <div class="small">
                                <mat-form-field class="form-field" appearance="outline">
                                    <input matInput formControlName="calendar" (keyup)="applyFilters()" autocomplete="off" />
                                    <button
                                        mat-icon-button
                                        matSuffix
                                        class="mat-accent search-icon"
                                        matTooltip="{{ 'Restrictions.ResetFilterColumn' | translate }}"
                                        (click)="resetColumnFilter('calendar')">
                                        <mat-icon>undo</mat-icon>
                                    </button>
                                </mat-form-field>
                            </div>
                        </th>
                        <td mat-cell *matCellDef="let element">{{ element.calendar }}</td>
                    </ng-container>

                    <ng-container matColumnDef="actions" stickyEnd>
                        <th mat-header-cell *matHeaderCellDef>
                            <button
                                mat-icon-button
                                matSuffix
                                class="header-button"
                                matTooltip="{{ 'Restrictions.ResetAllFiltersColumn' | translate }}"
                                (click)="resetAllColumnFilter()">
                                <mat-icon>undo</mat-icon>
                            </button>
                        </th>
                        <td mat-cell *matCellDef="let element">
                            <div class="action-column">
                                <button mat-icon-button routerLink="/restriction" [queryParams]="{ id: element.id }">
                                    <mat-icon>visibility</mat-icon>
                                </button>
                                <button mat-icon-button (click)="onDeleteClick(element.id, element.name)">
                                    <mat-icon>delete</mat-icon>
                                </button>
                            </div>
                        </td>
                    </ng-container>

                    <tr mat-header-row *matHeaderRowDef="displayedColumns; sticky: true"></tr>
                    <tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>
                </table>

                <mat-paginator [pageSizeOptions]="[25, 50, 100]" class="default-paginator"></mat-paginator>
            </div>
        </form>
    </div>
</div>
